<template>
    <div>
        <div v-for="message in error_messages"
            class="error-list-item flex flex-1 items-center"
        >
            <div class="text-red-500 text-lg w-8">
                <i class="fas fa-exclamation-triangle mr-1" aria-hidden="true"></i>
            </div>

            <p class="text-red-500 leading-tight">
                {{ $t(message) }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        errors: {
            type: Array,
            default: () => [],
        },
    },

    computed: {
        error_messages() {
            return this.errors.map(error => {
                return error[0] ?? error;
            });
        },
    },
}
</script>
